import { CrudType, HomeNavMenuType } from '@redux/index'

export interface MenuType {
	id: string
	name: string
	order?: number
	icon?: string
	to?: string
	children?: MenuType[]
	isDev?: boolean
	showMenu?: boolean
}

export interface SidePageType {
	id: string
	name: string
	to?: string
	targetCrud: CrudType
	parentPath: string
}

export const defaultMenu: MenuType = {
	id: 'home',
	name: 'Home',
	icon: '',
	to: '/home',
}

export const homeMenuList: HomeNavMenuType[] = [
	// { id: 'pedals', title: 'PEDALS', uri: './pedals' },
	{ id: 'home', title: 'HOME', uri: '/' },
	{ id: 'shop', title: 'SHOP', uri: '/shop' },
	{ id: 'support', title: 'SUPPORT', uri: '/support' },
	// { id: 'about', title: 'ABOUT', uri: '/about' },
	{ id: 'contact', title: 'CONTACT', uri: '/contact' },
]

export const customerSubMenuList: HomeNavMenuType[] = [
	{ id: 'myInfo', title: 'My Info', uri: '/customer/info' },
	{ id: 'myOrder', title: 'My Order', uri: '/customer/order' },
	{ id: 'changePassword', title: 'Change Password', uri: '/customer/change-password' },
	{ id: 'logout', title: 'Log out', uri: '/customer/logout' },
]

export const supportSubMenuList: HomeNavMenuType[] = [
	{ id: 'manuals', title: 'Manuals', uri: '/manuals' },
	{ id: 'privacyPolicies', title: 'Privacy Policy', uri: '/privacy-policy' },
	{ id: 'storePolicies', title: 'Store Policy', uri: '/store-policy' },
]

export const mobileMenuList = []

// id 앞에 prefix로 'admin'을 붙일 것
export const adminMenu: MenuType[] = [
	{
		id: 'adminUsers',
		name: '사용자 관리',
		icon: 'account-cog',
		to: '/admin/users',
	},
	{
		id: 'adminMenu',
		name: '메뉴 관리',
		icon: 'list-box',
		to: '/admin/menu',
	},
	{
		id: 'adminAccessControl',
		name: '권한 관리',
		icon: 'badge-account-outline',
		to: '/admin/access-control',
	},
]

export const sidePageList: SidePageType[] = [
	{
		id: 'resetPassword',
		name: '패스워드 변경',
		to: '/admin/reset-password',
		targetCrud: ['C', 'U'],
		parentPath: '/admin/users',
	},
	{
		id: 'userProfileImageUpdate',
		name: '프로필 이미지 변경',
		to: '/admin/user-profile-image-update',
		targetCrud: ['C', 'U'],
		parentPath: '/admin/users',
	},
	{
		id: 'createMenu',
		name: '새 메뉴 생성',
		to: '/admin/create-menu',
		targetCrud: ['C'],
		parentPath: '/admin/menu',
	},
	// main
	{
		id: 'resetCustomerPassword',
		name: '고객 비밀번호 변경',
		to: '/main/reset-customer-password',
		targetCrud: ['C', 'U'],
		parentPath: '/main/customer',
	},
]
